import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const CaseStudyHighlight = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-3xl overflow-hidden">
          <div className="grid lg:grid-cols-2 gap-12 p-12">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-6"
            >
              <div className="inline-block bg-blue-800/50 rounded-full px-4 py-2 text-blue-200">
                Case Study
              </div>
              <h2 className="text-3xl font-bold text-white">
                How We Increased Conversion Rates by 150%
              </h2>
              <p className="text-blue-100">
                Through systematic A/B testing and data-driven optimization, 
                we helped a leading e-commerce client achieve remarkable results 
                in just 3 months.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white/10 rounded-xl p-6">
                  <div className="text-3xl font-bold text-blue-300 mb-2">
                    150%
                  </div>
                  <div className="text-blue-100">
                    Conversion Rate Increase
                  </div>
                </div>
                <div className="bg-white/10 rounded-xl p-6">
                  <div className="text-3xl font-bold text-blue-300 mb-2">
                    45%
                  </div>
                  <div className="text-blue-100">
                    Bounce Rate Reduction
                  </div>
                </div>
              </div>
              <Link to="/case-studies">
                <Button 
                  className="bg-white text-blue-900 hover:bg-blue-50"
                >
                  Read Full Case Study
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="relative hidden lg:block"
            >
              <div className="absolute inset-0 bg-white/10 rounded-3xl transform rotate-3" />
              <div className="relative p-8">
                <img 
                  src="/lovable-uploads/97a3a0f7-3d71-4be5-9a09-4a44be857d6f.png"
                  alt="CRO Analysis Cycle"
                  className="w-full h-auto rounded-xl"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};